<script setup lang="ts">import { toRef as _toRef } from 'vue';

import { useFavoritesStore } from '@consumer/services/favorites/store'
import { useSharedData } from '@consumer/composables/sharedData'
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons'
import MyAccountApi from '@consumer/api/MyAccountApi'
import { asyncOpenModal } from '@consumer/services/modals'
import FlyOutToast from '../FlyOut/FlyOutToast.vue'
import Favorite from './Favorite.vue'

const favorites = useFavoritesStore()

const __$temp_1 = (useSharedData()),
  currentUser = _toRef(__$temp_1, 'currentUser');

async function openLoginOrSignupModal () {
  await asyncOpenModal(import('@consumer/modals/loginOrSignup/LoginOrSignUpModal.vue'))
}
</script>

<template>
  <FlyOutToast
    id="favorite-toast"
    :open="Boolean(favorites.lastAddedFavorite)"
    class="w-100"
    @close="favorites.lastAddedFavorite = undefined"
  >
    <Favorite
      v-if="favorites.lastAddedFavorite"
      :favorite="favorites.lastAddedFavorite"
    >
      <div class="flex flex-col gap-1">
        <span class="flex gap-1.5 items-center">
          <GIcon
            :icon="faCircleCheck"
            color="green-base"
            size="16px"
          />
          <span class="text-nowrap">
            Added to
            <GLink :href="MyAccountApi.favorites.path()" class="link font-semibold" @click.stop>Favorites</GLink>
          </span>
          <span v-if="currentUser" class="text-grey-400 text-2xl align-middle">
            •
          </span>
          <GPromiseButton
            v-if="currentUser && favorites.lastAddedFavorite"
            flat
            primary
            size="medium"
            label="Add to list"
            @click.prevent.stop="
              favorites.openAddToListModal(
                favorites.lastAddedFavorite,
                { onOpen: () => favorites.lastAddedFavorite = undefined }
              )
            "
          />
        </span>
        <div v-if="!currentUser" class="text-sm text-v2-tertiary">
          <GButton flat primary @click.prevent="openLoginOrSignupModal">Log in</GButton>
          <span> or </span>
          <GButton flat primary @click.prevent="openLoginOrSignupModal">Sign up</GButton>
          <span>
            to save for later
          </span>
        </div>
      </div>
    </Favorite>
  </FlyOutToast>
</template>
